import React from 'react';

const PuzzleIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='nonzero'>
      <g transform='translate(7.000000, 5.000000)'>
        <path d='M18.5,10 L17,10 L17,6 C17,4.89 16.1,4 15,4 L11,4 L11,2.5 C11,1.11928813 9.88071187,4.4408921e-16 8.5,4.4408921e-16 C7.11928813,4.4408921e-16 6,1.11928813 6,2.5 L6,4 L2,4 C0.8954305,4 0,4.8954305 0,6 L0,9.8 L1.5,9.8 C3,9.8 4.2,11 4.2,12.5 C4.2,14 3,15.2 1.5,15.2 L0,15.2 L0,19 C0,20.1045695 0.8954305,21 2,21 L5.8,21 L5.8,19.5 C5.8,18 7,16.8 8.5,16.8 C10,16.8 11.2,18 11.2,19.5 L11.2,21 L15,21 C16.1045695,21 17,20.1045695 17,19 L17,15 L18.5,15 C19.8807119,15 21,13.8807119 21,12.5 C21,11.1192881 19.8807119,10 18.5,10 Z' />
      </g>
    </g>
  </svg>
);

export default PuzzleIcon;
